import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Error404 from '../containers/Error404';
import Repairs from "../containers/repairs/Repairs";

class RepairRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path='/repair' component={Repairs}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default RepairRoute;



// WEBPACK FOOTER //
// ./src/routes/RepairRoute.js